<div class="_mobile-header-component" [class._open]="accountIsOpen">
    <div class="_main">
        <img src="{{userDetails?.logo || './assets/imgs/digibank.png'}}" class="_logo"/>
        <ion-icon *ngIf="!accountIsOpen" src="./assets/icons/person-outline.svg" (click)="toggleAccount()"></ion-icon> 
        <ion-icon *ngIf="accountIsOpen" src="./assets/icons/invalid-input.svg" (click)="toggleAccount()"></ion-icon> 
        <!-- <ion-icon *ngIf="accountIsOpen" src="./assets/icons/absent-outline.svg" (click)="toggleAccount()"></ion-icon>  -->

    </div>
    <div class="_account" *ngIf="accountIsOpen" >
        <p>
            {{'MOBILE_HEADER.TITLE' | translate}} {{userDetails.firstname}} {{userDetails.lastname}}
        </p>
        <u><b class="_logout-button" (click)="onClickLogout()" [translate]="'NAVIGATION.LOGOUT'"></b></u>
    </div>
</div>